<template>
  <div id="panel-product-awards-info">
    <div>
      <v-row class="mt-2 pt-2">
        <v-col md="5">
          <span>
            <strong>Rating - Based on 100 point system</strong>
          </span>
        </v-col>
        <v-col md="7">
          <span>
            <strong>Rated by</strong>
          </span>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-form :ref="awardsFormName" @submit.prevent>
        <div class="mt-2 pt-2">
          <v-row v-for="(award, index) in awards" :key="index">
            <v-col class="p-award-col" md="5">
              <v-text-field
                dense
                single-line
                outlined
                class="mt-0 pt-0"
                label="Rating"
                suffix="points"
                type="number"
                :disabled="viewModeOnly"
                :max="awardsRating.MAX_VALUE"
                :min="awardsRating.MIN_VALUE"
                v-model="award.rating"
                :rules="[
                  validRowFields(
                    award.rating,
                    award.ratedBy,
                    'Rating value required'
                  ),
                  validRating(award.rating, awardsRating)
                ]"
                @input="
                  (rating) => {
                    validateAwardsForm(awardsRating)
                    handleRatingChange(award, rating)
                  }
                "
              ></v-text-field>
            </v-col>
            <v-col class="p-award-col" md="7">
              <v-text-field
                dense
                outlined
                v-model="award.ratedBy"
                counter="100"
                maxlength="100"
                :disabled="viewModeOnly"
                :rules="[
                  validRowFields(
                    award.ratedBy,
                    award.rating,
                    'Rated by value required'
                  )
                ]"
                @change="(rating) => validateAwardsForm()"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import FieldValidators from '@/utils/FieldValidators'

export default {
  props: {
    awardsRating: {
      type: Object,
      default: () => {}
    },
    fieldsRulesValues: {
      type: Object,
      default: () => {}
    },
    newProduct: {
      type: Boolean,
      default: true
    },
    product: {
      type: Object,
      default: () => {}
    },
    viewModeOnly: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    awardsFormName: 'awardsForm',
    timeOutRating: null,
    ...FieldValidators
  }),

  computed: {
    awards() {
      return Object.values(this.product.liquorInformation.awards)
    }
  },

  methods: {
    handleRatingChange(award, rating) {
      if (rating === '') return

      const RATING_TIMEOUT = 750
      clearTimeout(this.timeOutRating)
      this.timeOutRating = setTimeout(() => {
        award.rating = this.maxNumberDecimals(rating, 0)
      }, RATING_TIMEOUT)
    },

    maxNumberDecimals(value, numberDecimals) {
      if (value < 0) return 0
      return Number(value).toFixed(numberDecimals)
    },

    validateAwardsForm() {
      this.$refs[this.awardsFormName].validate()
    },

    validRating(rating, awardsRating) {
      if (!rating) return true
      if (rating < awardsRating.MIN_VALUE)
        return `Minimum rating is ${awardsRating.MIN_VALUE}`
      if (rating > awardsRating.MAX_VALUE)
        return `Maximum rating is ${awardsRating.MAX_VALUE}`
      return true
    },

    validRowFields(alertableField, filledField, message = 'Provide value') {
      if (!alertableField && filledField) return message
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
#panel-product-awards-info {
  .p-award-col {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
</style>
